import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import login from '../views/login.vue';
import Home from '../views/Home.vue';
import Welcome from '../views/Welcome.vue';
// 管理项目
import managementItem from '../views/management-center/managementItem/index.vue';
// 访问项目
import projectVisit from '../views/management-center/projectVisit/index.vue';
// 中转页面
import transfer from '@/views/management-center/transfer/index.vue';
// 项目分析
import projectAnalysis from '@/views/management-center/projectAnalysis/index.vue';

const router = new VueRouter({
	routes: [
		{
			path: '/',
			redirect: (to) => {
				var tokenStr = window.sessionStorage.getItem('token');
				if (tokenStr == null) {
					return '/login';
				} else {
					return '/index';
				}
			}
		},
		{
			path: '/login',
			component: login,
			name: 'login',
			meta: { title: '登录' }
		},
		{ path: '/transfer', component: transfer, name: 'transfer', meta: { title: '中转页面' } },
		{
			path: '/',
			component: Home,
			name: 'Home',
			meta: { title: '数据看板' },
			children: [
				{ path: '/index', component: Welcome, name: 'Welcome', meta: { title: '数据看板' }, alias: '/index' },
				{ path: '/managementItem', component: managementItem, name: 'managementItem', meta: { title: '管理项目' } },
				{ path: '/projectVisit', component: projectVisit, name: 'projectVisit', meta: { title: '访问项目' } },
				{ path: '/projectAnalysis', component: projectAnalysis, name: 'projectAnalysis', meta: { title: '项目分析' } }
			]
		},
		{ path: '*', redirect: '/index' }
	]
});

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
	// to 将要访问的路径
	// from 代表从哪个路径跳转而来
	// next 是一个函数， 表示放行   ①next()放行   ②next('/login')强制跳转
	const token = window.sessionStorage.getItem('token');
	if (to.path === '/login') {
		if (token != null) {
			console.log('token！=null');
			return next('/index');
		}
		console.log('访问登录直接放行');
		return next();
	} // 访问登录页，直接放行
	// 获取token

	// 如果token过期了
	if (!token) {
		if (to.path == '/login') return next();
		// 注意要import element的Message组件
		alert('登录状态过期，请重新登录');
		return next('/login');
		// 如果token没有过期，又是选择了登录页面就直接重定向到首页，不需要重新输入账户密码
	} else if (to.path == '/login') {
		return next('');
	}
	// if (!token) {
	// 	console.log('没有token强制跳转');
	// 	return next('/login'); // 没有token 强制跳转
	// }

	// 获取存储token的开始时间
	const tokenStartTime = window.sessionStorage.getItem('tokenStartTime');
	// 后台给出的token有效时间，一个星期 单位 是秒
	// 我们自己定义6个小时过期，让用户重新登录一下， 用户总不可能在一个页面挂机一天吧
	const timeOver = 21600000; //21600000
	// console.log(timeOver);
	// 当前时间
	let date = new Date().getTime();
	// 如果大于说明是token过期了
	if (date - tokenStartTime > timeOver) {
		sessionStorage.removeItem('token');
		token = null;
	}
	next(); // 否则直接放行
});

export default router;
